import React, { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

const ThankYou = () => {

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18303703989/waUNCMa47MscELW38ZdE",
        value: 1.0,
        currency: "USD"
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1A1A] to-[#1A1A1A] flex items-center justify-center relative overflow-hidden">
      <SEO 
        title="Thank You | Book Creation Studio"
        description="Thank you for choosing Book Creation Studio"
        url="/thank-you"
      />
      
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8 items-stretch w-full relative">
          <div  className="flex flex-col justify-center w-full">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#F4D03F] mb-4 uppercase font-light">Thank You</h1>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#ffffff] mb-4 uppercase font-light">for Signing Up</h1>
            <p className="text-lg text-gray-400 mb-8">
              Your client portal access details have been sent to the email address you provided. If the email doesn't appear within a few minutes, please check your inbox and spam or junk folder. 
            </p>
            <p className="text-lg text-gray-400 mb-8">
              One of our representatives will contact you within the next 24 hours to discuss your project and explain the next steps.
            </p>
            <p className="text-lg text-gray-400 mb-8">
              If you need immediate assistance, call: <a href="tel:+1 (888) 655 0682" className="text-[#F4D03F] hover:text-[#F8D26B] transition-colors">+1 (888) 655 0682</a>
            </p>

            <a href="javascript:;" className="group w-auto inline-flex self-start items-center gap-2 bg-[#F4D03F] hover:bg-[#F8D26B] text-[#0a0a0a] font-bold py-3 px-8 rounded-lg transition-colors">
              Access Client Portal <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5" />
            </a>
          </div>
          
          
        </div>
      </div>

      <div
            className="hidden lg:flex lg:col-start-2"
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: '100%',
              pointerEvents: 'none',
              top: 0,
              margin: 'auto',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}
          >
            <img 
              src="/assets/img/thankyou-right-img.png" 
              alt="Thank You" 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
      
    </div>
  );
};

export default ThankYou;
